import { useContext, memo } from 'react';
import { Bar, Chart } from 'react-chartjs-2';
import type { ChartData, ChartOptions } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import {
  carbonCostChartOption,
  carbonCostChartData
} from './carbonCostChartData';
import { CalculatedDataContext, AllInputDataContext } from '../../../config';
import styles from './../AllCharts.module.css';

Chart.register(annotationPlugin);

type Props = { metric: 'carbon' | 'cost' };

const CarbonCostGenerationChart = memo(({ metric }: Props) => {
  const { annualConst } = useContext(CalculatedDataContext);
  const { optionsData } = useContext(AllInputDataContext);

  const chartData = carbonCostChartData({ annualConst, optionsData, metric });
  const chartOptions = carbonCostChartOption({ metric });

  return (
    <div className={styles.dataChart}>
      <div className={styles.chartInnerCard}>
        {/* Narrow the generic helper return to the bar chart at the boundary. */}
        <Bar
          data={chartData as ChartData<'bar'>}
          options={chartOptions as ChartOptions<'bar'>}
        />
      </div>
    </div>
  );
});

export default CarbonCostGenerationChart;
